export interface TblDetalleSolicitudAyud {
    iddetallesolicitudayud: number;
    idplanifayudantias: number;
    idunidad: number;
    numhoras?: number; // Campo opcional debido al tipo `int?`
    tipo: string;
    estado: string;
    ultimocambio: Date;
    numayudantias?: number; // Campo opcional debido al tipo `int?`
    numayudantiasotorgadas?: number; // Campo opcional debido al tipo `int?`
    numhorasotorgadas?: number; // Campo opcional debido al tipo `int?`
    idsolicitudayud: number;
    fechainicio?: Date; // Campo opcional debido al tipo `DateTime?`
    fechafin?: Date; // Campo opcional debido al tipo `DateTime?`
    observacion: string;
    esadhonorem: string;
  }

  export function VoidTblDetalleSolicitudAyud(): TblDetalleSolicitudAyud {
    return {
      iddetallesolicitudayud: 0,
      idplanifayudantias: 0,
      idunidad: 0,
      numhoras: undefined, // Campo opcional
      tipo: '',
      estado: '',
      ultimocambio: new Date(0), // Fecha predeterminada (01/01/1970)
      numayudantias: undefined, // Campo opcional
      numayudantiasotorgadas: undefined, // Campo opcional
      numhorasotorgadas: undefined, // Campo opcional
      idsolicitudayud: 0,
      fechainicio: undefined, // Campo opcional
      fechafin: undefined, // Campo opcional
      observacion: '',
      esadhonorem: ''
    };
  }